import {Controller} from "@hotwired/stimulus"
import {patch} from "@rails/request.js"

// Connects to data-controller="dashboard-customization"
export default class extends Controller {
  static targets = ["checkbox"]

  static values = {
    id: Number,
    url: String,
    visible: Boolean,
  }

  async toggleVisibility(event) {
    event.stopPropagation()

    // Disable the toggle while request is in progress
    const toggleElement = event.currentTarget
    toggleElement.style.pointerEvents = 'none'
    toggleElement.style.opacity = '0.6'

    try {
      const response = await patch(this.urlValue, {
        contentType: "application/json",
        body: {
          dashboard_customization: {
            visible: !this.visibleValue
          }
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      // Update the visible value for next toggle
      this.visibleValue = !this.visibleValue

    } catch (error) {
      console.error('Error updating dashboard customization:', error)

      // Show user-friendly error message
      const errorMsg = document.createElement('div')
      errorMsg.className = 'alert alert-danger'
      errorMsg.textContent = 'Failed to update dashboard section. Please try again.'
      errorMsg.style.position = 'fixed'
      errorMsg.style.top = '20px'
      errorMsg.style.right = '20px'
      errorMsg.style.zIndex = '9999'

      document.body.appendChild(errorMsg)

      // Remove error message after 3 seconds
      setTimeout(() => {
        if (errorMsg.parentNode) {
          errorMsg.parentNode.removeChild(errorMsg)
        }
      }, 3000)

    } finally {
      // Re-enable the toggle
      toggleElement.style.pointerEvents = ''
      toggleElement.style.opacity = ''
    }
  }
}
